import PropTypes from 'prop-types';

import ButtonDisclosures from '../../../atoms/button-disclosures';
import CardModule from '../../shared/card-module';
import TableBasic from '../../../atoms/table-basic';
import format from '../../../../utils/format';
import styles from './investment-facts.module.scss';
import { augmentClassName } from '../../../../utils/GlobalCssProxy';

const className = augmentClassName(styles);

const InvestmentFacts = ({
  facts,
  ticker,
  header,
  headerAsOfDate,
  hideDisclosure = false,
  isNonPropATA = false
}) => {
  const formattedInvestmentFacts = facts && facts.length ? facts : [{ title: '--', value: '--' }];
  const hasHeaderAsOfDate = typeof headerAsOfDate !== 'undefined';
  if (isNonPropATA && formattedInvestmentFacts.length > 1) {
    formattedInvestmentFacts.pop();
  }
  return (
    <CardModule
      data-analytics-componenttype="half-width-component"
      data-analytics-id="HW_InvestmentFacts"
      data-analytics-section="component"
    >
      <CardModule.Header>
        {header}
        {hasHeaderAsOfDate && (
          <CardModule.AsOfDate>{format.date(headerAsOfDate)}</CardModule.AsOfDate>
        )}
      </CardModule.Header>
      <CardModule.Body>
        <TableBasic flush {...className('print-investment-facts')}>
          <caption {...className('sr-only')}>{`${header} for ${ticker}`}</caption>
          <thead>
            <tr>
              <th {...className('sr-only')}>Fact Titles</th>
              <th {...className('sr-only')}>Fact Values</th>
            </tr>
          </thead>
          <tbody>
            {formattedInvestmentFacts
              .filter(item => item.value !== null)
              .map((item, index) => {
                return (
                  <tr
                    data-key={`${item.title || ''}-${index}`}
                    key={`${item.title || ''}-${index}`}
                    {...className('border-bottom')}
                  >
                    <th scope="row" {...className('text-left')}>
                      {format.text(item.title)}
                    </th>
                    <td {...className('text-right', 'font-weight-bold')}>
                      {item.value}
                      {item.hasOwnProperty('asOfDate') ? (
                        <p
                          {...className(
                            'font-weight-normal',
                            'text-muted',
                            'mt-1',
                            'mb-0',
                            'in-row-as-of-date'
                          )}
                        >
                          As of {item.asOfDate}
                        </p>
                      ) : undefined}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </TableBasic>
      </CardModule.Body>
      {!hideDisclosure && (
        <CardModule.Footer {...className('text-right')}>
          <ButtonDisclosures module={'investment-facts'} />
        </CardModule.Footer>
      )}
    </CardModule>
  );
};

InvestmentFacts.propTypes = {
  hideDisclosure: PropTypes.bool,
  isNonPropATA: PropTypes.bool,
  ticker: PropTypes.string,
  header: PropTypes.string,
  facts: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  ),
  headerAsOfDate: PropTypes.string
};

InvestmentFacts.defaultProps = {
  facts: []
};

export default InvestmentFacts;
